module.exports = __webpack_public_path__ + "img/characterAnime16.892b9d58.png";